import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_night_mode_line.png'
import _imports_1 from '@/assets/images/icon_brightness_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0187574f")

_pushScopeId("data-v-0187574f")
const _hoisted_1 = { class: "fridgeeconavi-contentitem" }
const _hoisted_2 = { class: "fridgeeconavi-contentitem-graph" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-filler" }, null, -1)
const _hoisted_4 = { class: "fridgeeconavi-contentitem-graph-graph" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale" }, [
  /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-zero" }, "0"),
  /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle" }, [
    /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-pm" }, [
      /*#__PURE__*/_createVNode("span", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-pm-text" }, "PM")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-18" }, [
      /*#__PURE__*/_createVNode("span", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-18-text" }, "18")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-innercircle" }, [
      /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-innercircle-upper" }, [
        /*#__PURE__*/_createVNode("img", {
          class: "fridgeeconavi-contentitem-graph-graph-scale-middle-innercircle-upper-image",
          src: _imports_0
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-innercircle-lower" }, [
        /*#__PURE__*/_createVNode("img", {
          class: "fridgeeconavi-contentitem-graph-graph-scale-middle-innercircle-lower-image",
          src: _imports_1
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-6" }, [
      /*#__PURE__*/_createVNode("span", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-6-text" }, "6")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-am" }, [
      /*#__PURE__*/_createVNode("span", { class: "fridgeeconavi-contentitem-graph-graph-scale-middle-am-text" }, "AM")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-scale-12" }, "12")
], -1)
const _hoisted_6 = { class: "fridgeeconavi-contentitem-graph-graph-legend" }
const _hoisted_7 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content" }
const _hoisted_8 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend" }
const _hoisted_9 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-color fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-color-enable" }, null, -1)
const _hoisted_11 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-description" }
const _hoisted_12 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-description-text" }
const _hoisted_13 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item fridgeeconavi-contentitem-graph-graph-legend-content-legend-lowitem" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-color fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-color-disable" }, null, -1)
const _hoisted_15 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-description" }
const _hoisted_16 = { class: "fridgeeconavi-contentitem-graph-graph-legend-content-legend-item-description-text" }
const _hoisted_17 = {
  key: 0,
  class: "fridgeeconavi-contentitem-ratio"
}
const _hoisted_18 = { class: "fridgeeconavi-contentitem-ratio-title" }
const _hoisted_19 = { class: "fridgeeconavi-contentitem-ratio-title-text" }
const _hoisted_20 = { class: "fridgeeconavi-contentitem-ratio-value" }
const _hoisted_21 = { class: "fridgeeconavi-contentitem-ratio-value-value" }
const _hoisted_22 = { class: "fridgeeconavi-contentitem-ratio-value-value-text" }
const _hoisted_23 = { class: "fridgeeconavi-contentitem-ratio-value-unit" }
const _hoisted_24 = { class: "fridgeeconavi-contentitem-ratio-value-unit-text" }
const _hoisted_25 = { class: "fridgeeconavi-contentitem-ratio-note" }
const _hoisted_26 = { class: "fridgeeconavi-contentitem-ratio-note-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("canvas", {
          class: "fridgeeconavi-contentitem-graph-graph-canvas",
          ref: "canvas",
          width: _ctx.canvasSize.width,
          height: _ctx.canvasSize.height
        }, null, 8, ["width", "height"]),
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.firstLegendTitle), 1)
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.secondLegendTitle), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isValidRation)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, _toDisplayString(_ctx.ratioTitleText), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.info.operating_rate), 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.percentText), 1)
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("span", _hoisted_26, _toDisplayString(_ctx.noteText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})